/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorBeneficiariosExclusaoAliases {
  BUTTON_CONFIRMAR = 'button-confirmar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_BENEFICIARIOS = 'deck-beneficiarios',
  FETCH_BENEFICIARIOS = 'fetch-beneficiarios',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_TITULAR = 'field-titular',
  FILTER_BENEFICIARIOS = 'filter-beneficiarios',
  FILTERED_LIST_EXCLUSAO_BENEFICIARIOS = 'filtered-list-exclusao-beneficiarios',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  HPMS_CUSTOM_CARD_BENEFICIARIOS = 'hpms-custom-card-beneficiarios',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  PANEL_LOCATOR_BENEFICIARIOS = 'panel-locator-beneficiarios',
  TEXT_CARTEIRA = 'text-carteira',
  TEXT_TITULO = 'text-titulo',
}
export { LocatorBeneficiariosExclusaoAliases };
